module.exports = __webpack_public_path__ + "img/banner2_12.66785ee8.png";